/// <reference types="vite/client" />

const API_BASE = import.meta.env.VITE_API_BASE || "/api"

export interface ApiError {
  status: number
  title: string
  detail?: string
  code?: string
}

export class ApiClientError extends Error {
  status: number
  detail?: string
  code?: string

  constructor(error: ApiError) {
    super(error.detail || error.title)
    this.status = error.status
    this.detail = error.detail
    this.code = error.code
  }
}

interface RequestOptions {
  method?: string
  body?: unknown
  token?: string | null
  deviceUuid?: string | null
  idempotencyKey?: string
  signal?: AbortSignal
}

export async function apiRequest<T>(path: string, opts: RequestOptions = {}): Promise<T> {
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
    "Accept": "application/json"
  }
  if (opts.token) headers["Authorization"] = `Bearer ${opts.token}`
  if (opts.deviceUuid) headers["X-Device-Uuid"] = opts.deviceUuid
  if (opts.idempotencyKey) headers["Idempotency-Key"] = opts.idempotencyKey

  const url = path.startsWith("/") ? `${API_BASE}${path.replace(/^\/api/, "")}` : `${API_BASE}/${path}`

  const response = await fetch(url, {
    method: opts.method || "GET",
    headers,
    body: opts.body ? JSON.stringify(opts.body) : undefined,
    signal: opts.signal
  })

  if (!response.ok) {
    let errorBody: ApiError
    try {
      const json = await response.json()
      errorBody = {
        status: response.status,
        title: json.title || "Greška",
        detail: json.detail,
        code: json.code
      }
    } catch {
      errorBody = { status: response.status, title: response.statusText }
    }
    throw new ApiClientError(errorBody)
  }

  if (response.status === 204) return undefined as T
  return response.json()
}
